module.exports = __webpack_public_path__ + "static/img/csbuto.c95543f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/csbuto.png
// module id = 22hK
// module chunks = 0